/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, h } from './index-ef0fa435.js';

const DoorContent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.color = undefined;
    this.disabled = undefined;
    this.value = undefined;
  }
  // @Event() click!: EventEmitter; // populates
  render() {
    return (h("lar-button", { disabled: this.disabled, color: this.color }, h("lar-translate", { t: this.value })));
  }
};

export { DoorContent as lar_door_content };

//# sourceMappingURL=lar-door-content.entry.js.map